module.exports = __webpack_public_path__ + "img/nodata.028e7c95.png";